import InvoicesListItem from './InvoicesListItem';

export default InvoicesListItem;
